import { render, staticRenderFns } from "./PsoriasisAffectedAreasPhaseV2.vue?vue&type=template&id=7688169a&scoped=true&"
import script from "./PsoriasisAffectedAreasPhaseV2.vue?vue&type=script&lang=js&"
export * from "./PsoriasisAffectedAreasPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisAffectedAreasPhaseV2.vue?vue&type=style&index=0&id=7688169a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688169a",
  null
  
)

export default component.exports